import { render, staticRenderFns } from "./addstoreinfo.vue?vue&type=template&id=cd808d96&scoped=true&"
import script from "./addstoreinfo.vue?vue&type=script&lang=js&"
export * from "./addstoreinfo.vue?vue&type=script&lang=js&"
import style0 from "./addstoreinfo.vue?vue&type=style&index=0&id=cd808d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd808d96",
  null
  
)

export default component.exports